/**
 * Breadcrumb das telas /canais/:id/... quando o canal nao carrega: nao ha nome
 * para mostrar, entao fica o id da rota.
 */
export function getChannelNotFoundBreadcrumb(channelId:string|number):any[] {
    return [
        {
            id: 0,
            description: 'Canais',
            path: '/canais',
        },
        {
            id: 1,
            description: `Canal #${channelId}`,
            path: '',
        },
    ]
}
